var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersoHorizontalBrancoSemAssinatura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480.03 139.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-6);}.cls-2{clip-path:url(#clippath-7);}.cls-3{clip-path:url(#clippath-4);}.cls-4{clip-path:url(#clippath-9);}.cls-5{clip-path:url(#clippath-10);}.cls-6{fill:#fff;}.cls-7{clip-path:url(#clippath-11);}.cls-8{fill:none;}.cls-9{clip-path:url(#clippath-1);}.cls-10{fill:#231f20;}.cls-11{isolation:isolate;}.cls-12{clip-path:url(#clippath-5);}.cls-13{clip-path:url(#clippath-8);}.cls-14{clip-path:url(#clippath-3);}.cls-15{clip-path:url(#clippath-12);}.cls-16{clip-path:url(#clippath-2);}.cls-17{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 480.03,
    height: 139.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M163.06,49.24l13.18,31.4h-26.37l13.18-31.4h0ZM162.79,23.82c-5.71,0-9.92,3.13-12.23,8.29l-33.17,74.9c-.68,1.49-1.23,3-1.23,4.49,0,5.44,4.21,9.78,9.65,9.78,4.35,0,7.88-2.44,9.65-6.53l6.66-15.63h41.87l6.39,14.96c1.9,4.35,5.17,7.2,10.06,7.2,5.57,0,9.92-4.49,9.92-10.06,0-1.36-.41-2.72-1.08-4.22l-33.17-74.9c-2.31-5.16-6.39-8.29-12.1-8.29h-1.22Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.3,44.21h20.8c10.19,0,16.45,4.62,16.45,13.59v.27c0,8.02-5.84,13.46-16.04,13.46h-21.2v-27.32h0ZM231.83,25.32c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-20.79h16.71l20.39,25.83c2.44,3.12,5.57,5.44,10.33,5.44,5.03,0,9.93-3.8,9.93-9.65,0-3.26-1.36-5.43-3.4-8.02l-14.55-17.67c11.55-4.75,19.04-14,19.04-28.95v-.27c0-8.98-2.86-16.45-8.16-21.75-6.25-6.25-15.63-9.65-27.73-9.65h-33.03v-.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M335.13,44.21h16.17c10.47,0,16.99,5.03,16.99,14.41v.27c0,8.16-6.11,14.41-16.58,14.41h-16.58v-29.09h0ZM324.66,25.32c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-18.89h15.9c21.34,0,38.47-11.42,38.47-33.44v-.27c0-19.44-13.73-32.9-36.43-32.9h-28.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M459.1,34.96v28.01h-38.61v-28.01c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46v75.85c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47v-28.55h38.61v28.55c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47V34.96c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.66,2.36l-11.85,8.66c-.47.34-.91.7-1.32,1.09.41-.39.85-.75,1.32-1.09L21.66,2.36c2.23-1.6,4.81-2.36,7.39-2.36-2.58,0-5.16.77-7.39,2.36M40.05,5.72c2.7,3.78,3.23,8.43,1.82,12.41,1.41-3.98.88-8.63-1.82-12.41C37.38,1.99,33.22-.01,29.05-.01c4.17,0,8.33,2,11,5.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 6.91,
    y: -1.35,
    width: 37.29,
    height: 20.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -50.15,
    y: -127.85,
    width: 605.28,
    height: 429.53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.06,49.24l13.18,31.4h-26.37l13.18-31.4h0ZM162.79,23.82c-5.71,0-9.92,3.13-12.23,8.29l-33.17,74.9c-.68,1.5-1.23,3-1.23,4.49,0,5.44,4.21,9.79,9.65,9.79,4.35,0,7.88-2.44,9.65-6.53l6.66-15.63h41.87l6.39,14.96c1.9,4.35,5.17,7.2,10.06,7.2,5.57,0,9.92-4.49,9.92-10.06,0-1.36-.41-2.72-1.09-4.22l-33.17-74.9c-2.32-5.16-6.39-8.29-12.1-8.29h-1.22,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 116.16,
    y: 23.82,
    width: 94.2,
    height: 97.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.3,44.21h20.8c10.19,0,16.45,4.62,16.45,13.59v.27c0,8.02-5.84,13.46-16.04,13.46h-21.2v-27.32h0ZM231.83,25.32c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-20.79h16.71l20.39,25.83c2.44,3.12,5.57,5.44,10.33,5.44,5.03,0,9.93-3.8,9.93-9.65,0-3.26-1.36-5.44-3.4-8.02l-14.55-17.67c11.55-4.75,19.04-14,19.04-28.95v-.27c0-8.98-2.86-16.45-8.16-21.75-6.25-6.25-15.63-9.65-27.73-9.65h-33.03v-.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 221.36,
    y: 25.32,
    width: 79.39,
    height: 95.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.13,44.21h16.17c10.47,0,16.99,5.03,16.99,14.41v.27c0,8.16-6.11,14.41-16.58,14.41h-16.58v-29.09h0ZM324.66,25.32c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-18.89h15.9c21.34,0,38.47-11.42,38.47-33.44v-.27c0-19.44-13.73-32.9-36.43-32.9h-28.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 314.2,
    y: 25.32,
    width: 75.31,
    height: 95.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M459.1,34.96v28.01h-38.61v-28.01c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46v75.85c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47v-28.55h38.61v28.55c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47V34.96c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 399.56,
    y: 24.5,
    width: 80.47,
    height: 96.79
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65,45.03L9.82,86.74c-.48.35-.94.72-1.36,1.12-.2.28-1.27,1.86-1.27,3.32,0,1.38.94,2.66,4.45,2.66h33.34l56.62-42.79c.07-.1,1.3-1.79,1.3-3.36,0-1.38-.94-2.66-4.46-2.66h-33.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.14,94.33H11.63c-1.98,0-3.39-.41-4.19-1.2-.51-.51-.77-1.17-.77-1.96,0-1.68,1.23-3.42,1.37-3.61.49-.49.97-.88,1.47-1.24l55.31-41.8h33.61c2.01,0,3.38.39,4.19,1.2.51.51.77,1.17.77,1.96,0,1.77-1.34,3.58-1.4,3.66l-.1.1s-56.75,42.89-56.75,42.89ZM8.8,88.22s-1.11,1.57-1.12,2.96c0,.52.15.92.48,1.25.6.6,1.77.91,3.48.91h33.17l56.42-42.64c.2-.29,1.16-1.73,1.16-3.01,0-.52-.15-.93-.48-1.25-.6-.6-1.77-.91-3.48-.91h-33.27L10.11,87.13c-.47.34-.91.7-1.31,1.08"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-11",
    width: 35,
    height: 20,
    transform: "translate(7.32 19.49) scale(1.05 -1.05)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAVCAYAAAAuJkyQAAAACXBIWXMAAAqcAAAKnAH00t8SAAAAN0lEQVRIie3OIQ4AIBDEQJb//3lROJLKS0hHVTZtu4Ylye09OfLiEHGIOEQcIg4Rh4hDxCF95wCJogQkiymLcQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.66,2.36l-11.85,8.66c-.47.34-.92.7-1.33,1.09h0s-1.3,1.75-1.3,3.36c0,1.38.94,2.66,4.45,2.66h30.23c1.41-3.98.88-8.63-1.82-12.41C37.37,1.99,33.21-.01,29.04-.01c-2.58,0-5.16.77-7.39,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.22,18.63H11.63c-1.98,0-3.39-.4-4.19-1.2-.51-.51-.77-1.17-.77-1.96,0-1.76,1.34-3.58,1.4-3.66.48-.47.94-.85,1.44-1.2L21.36,1.96c2.25-1.61,4.91-2.46,7.69-2.46,4.48,0,8.74,2.22,11.4,5.94,2.7,3.77,3.4,8.58,1.88,12.86l-.12.33h.01ZM8.86,12.44c-.35.48-1.17,1.87-1.18,3.03,0,.52.16.92.48,1.25.6.6,1.77.91,3.48.91h29.88c1.26-3.89.57-8.2-1.87-11.61-2.47-3.46-6.43-5.52-10.59-5.52-2.57,0-5.03.78-7.1,2.27l-11.85,8.65c-.45.32-.86.66-1.25,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M.47,23.88v13.29c1.6,4.31,5.11,7.39,9.98,7.78.44.05.89.08,1.36.08h86.62c3.51,0,4.46,1.28,4.45,2.66,0,1.61-1.3,3.37-1.3,3.37,4.43-2.93,8.95-9.06,8.97-19.46,0-7.06-4.15-12.83-10.94-13.38-.44-.05-.89-.08-1.36-.08H11.64c-3.51,0-4.46-1.28-4.45-2.66,0-1.61,1.3-3.36,1.3-3.36-3.2,2.12-6.45,5.91-8.01,11.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.51,53.02l1.67-2.27s1.2-1.64,1.2-3.07c0-.52-.15-.93-.48-1.25-.6-.6-1.77-.91-3.48-.91H11.82c-.47,0-.93-.03-1.42-.08-4.84-.39-8.63-3.35-10.39-8.11l-.03-.17.02-13.41c1.38-5.19,4.3-9.47,8.22-12.06l2.35-1.56-1.68,2.27s-1.2,1.64-1.21,3.07c0,.52.15.92.48,1.25.6.6,1.77.91,3.48.91h86.62c.48,0,.95.03,1.42.08,6.69.54,11.38,6.25,11.38,13.88-.03,12.48-6.44,18.06-9.19,19.88l-2.35,1.55h0ZM.97,37.08c1.64,4.33,5.1,7.02,9.52,7.38.46.05.89.08,1.32.08h86.62c2.01,0,3.38.39,4.19,1.2.51.51.77,1.17.77,1.96,0,.54-.13,1.08-.3,1.58,2.92-2.59,6.95-7.93,6.97-17.68,0-7.2-4.21-12.37-10.48-12.88-.44-.05-.88-.07-1.32-.07H11.64c-1.98,0-3.39-.41-4.18-1.2-.51-.51-.77-1.17-.77-1.96,0-.54.13-1.08.31-1.58-2.09,1.84-4.65,5-6.02,10.06v13.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.2,120.73c-.49,1.4-.75,2.87-.76,4.37-.02,2.77.82,5.59,2.57,8.04,2.67,3.73,6.83,5.73,11,5.73,2.58,0,5.17-.77,7.4-2.36l11.85-8.66c.47-.34.92-.7,1.33-1.09.08-.1,1.3-1.8,1.3-3.36,0-1.38-.94-2.66-4.45-2.66h-30.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M81.01,139.37c-4.48,0-8.74-2.22-11.4-5.94-1.76-2.46-2.69-5.34-2.67-8.33.01-1.56.27-3.09.79-4.53l.12-.33h30.59c1.98,0,3.39.41,4.19,1.2.51.51.77,1.17.77,1.96,0,1.77-1.34,3.58-1.4,3.66-.47.46-.94.84-1.44,1.2l-11.85,8.65c-2.25,1.61-4.91,2.46-7.69,2.46M68.56,121.23c-.4,1.24-.61,2.54-.62,3.87-.02,2.78.84,5.45,2.48,7.75,2.48,3.46,6.43,5.52,10.59,5.52,2.57,0,5.03-.78,7.11-2.27l11.85-8.65c.47-.33.9-.69,1.28-1.05,0,0,1.14-1.6,1.14-3,0-.52-.15-.93-.48-1.25-.6-.6-1.77-.91-3.48-.91h-29.88,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M.47,99.59v13.28c1.6,4.31,5.11,7.4,9.98,7.79.44.04.89.07,1.36.07h86.62c3.51,0,4.46,1.28,4.45,2.66,0,1.62-1.3,3.37-1.3,3.37,4.43-2.93,8.95-9.06,8.97-19.47,0-7.06-4.15-12.83-10.94-13.38-.44-.05-.89-.07-1.36-.07H11.64c-3.51,0-4.46-1.28-4.45-2.66,0-1.61,1.3-3.36,1.3-3.36-3.2,2.12-6.45,5.91-8.01,11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.51,128.73l1.68-2.27s1.2-1.64,1.2-3.07c0-.52-.15-.93-.48-1.25-.6-.6-1.77-.91-3.48-.91H11.82c-.45,0-.92-.02-1.41-.07-4.84-.39-8.63-3.35-10.4-8.11l-.03-.17.02-13.41c1.87-7,5.95-10.56,8.22-12.06l2.35-1.56-1.68,2.27s-1.2,1.64-1.21,3.07c0,.52.15.92.48,1.25.6.6,1.77.91,3.48.91h86.62c.48,0,.95.03,1.42.08,6.69.54,11.38,6.25,11.38,13.88-.03,12.48-6.44,18.06-9.19,19.89l-2.36,1.56v-.03ZM.97,112.78c1.64,4.33,5.1,7.02,9.52,7.38.47.05.9.07,1.32.07h86.62c1.98,0,3.39.41,4.19,1.2.51.51.77,1.17.77,1.96,0,.54-.13,1.08-.3,1.58,2.92-2.59,6.95-7.93,6.97-17.68,0-7.2-4.21-12.37-10.48-12.88-.44-.05-.88-.07-1.32-.07H11.64c-1.98,0-3.39-.41-4.18-1.2-.51-.51-.77-1.17-.77-1.96,0-.54.13-1.08.31-1.58-2.09,1.84-4.65,5-6.02,10.06v13.13h-.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersoHorizontalBrancoSemAssinatura);
export default __webpack_public_path__ + "static/media/Versão_horizontal_branco_sem_assinatura.bf6976b710a2f504d5be646c2759aac3.svg";
export { ForwardRef as ReactComponent };